import React, { useRef, useState } from "react";
import clsx from "clsx";
import { Overlay } from "react-bootstrap";

import overlayImg from "static/images/overlayTrigger.png";
import styles from "./urlInfoIcon.module.scss";

const UrlInfoIcon = ({ width, alt, placement = "bottom" }) => {
	const [show, setShow] = useState(false);
	const target = useRef(null);

	const onMouseEnter = () => {
		setShow(true);
	};

	const onMouseLeave = () => {
		setShow(false);
	};

	return (
		<>
			<img
				src={overlayImg}
				ref={target}
				onMouseOver={onMouseEnter}
				onMouseOut={onMouseLeave}
				width={width}
				alt={alt}
				className={styles.urlInfoIcon}
			/>
			<Overlay target={target.current} show={show} placement={placement}>
				{({
					placement,
					scheduleUpdate,
					arrowProps,
					outOfBoundaries,
					show: _show,
					...props
				}) => {
					return (
						<div
							{...props}
							className={clsx(
								styles.urlInfoTooltip,
								placement === "top"
									? styles.top
									: styles.bottom,
							)}
							style={props.style}
						>
							The link is configured under Agent Office
							<br />
							level. If you are missing any info from
							<br />
							the link please contact your manager
							<br />
							or system administrator for further
							<br />
							instructions.
							<div className={styles.triangle} />
						</div>
					);
				}}
			</Overlay>
		</>
	);
};

export default UrlInfoIcon;
